import {
  INDIVIDUAL_SOURCE_TYPE,
  RENTAL_INCOME_TYPE_CODE,
  TAX_RATE,
} from 'modules/Taps/components/NDFL3LightRentalIncome/constants';

/**
 * Check if source is applicable for rental income scenario
 * @param {Map} source
 * @returns {boolean}
 */
export const isApplicableSource = (source) => {
  const incomes = source.get('incomes');

  return (
    source.get('sourceTypeSelector') === INDIVIDUAL_SOURCE_TYPE &&
    source.get('taxRate') === TAX_RATE &&
    incomes &&
    incomes.size === 1 &&
    incomes.first().get('incomeTypeCode') === RENTAL_INCOME_TYPE_CODE
  );
};
